import { render, staticRenderFns } from "./ConfigurationError.vue?vue&type=template&id=518e6fe2&"
import script from "./ConfigurationError.vue?vue&type=script&lang=js&"
export * from "./ConfigurationError.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src781945140/src/BedBoard.Sdk.Receiver/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('518e6fe2', component.options)
    } else {
      api.reload('518e6fe2', component.options)
    }
    module.hot.accept("./ConfigurationError.vue?vue&type=template&id=518e6fe2&", function () {
      api.rerender('518e6fe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ConfigurationError.vue"
export default component.exports